<template>
  <CommonList
    selection-type="checkbox"
    row-key="id"
    :has-more-search="false"
    :auto-load="true"
    ref="listRef"
    cell-overflow="ellipsis"
    @selection-change="handleSelectionChange"
    @load-start="handleLoadList"
    @search-click="handleLoadList"
    @pagination-change="handleLoadList"
    @reset-click="handleReset"
  >
    <template #search-item-fixed>
      <div class="common-search-item">
        <label class="common-search-label80">物品名称:</label>
        <el-input v-model="searchForm.itemName" class="common-input150" placeholder="请输入"></el-input>
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">结算状态:</label>
        <el-select v-model="searchForm.settleStatus" class="common-input120" placeholder="请选择" clearable>
          <el-option label="待结算" value="0"></el-option>
          <el-option label="已结算" value="1"></el-option>
        </el-select>
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">核验时间:</label>
        <el-date-picker
          v-model="searchForm.verifyTimeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="YYYY-MM-DD"
          class="common-input240"
          clearable
        />
      </div>
      <template v-if="isAdmin">
        <div class="common-search-item">
          <label class="common-search-label80">核验员:</label>
          <el-input v-model="searchForm.verifyUsername" class="common-input150" placeholder="请输入"></el-input>
        </div>
        <div class="common-search-item">
          <label class="common-search-label80">核验员编号:</label>
          <el-input v-model="searchForm.verifyUserId" class="common-input150" placeholder="请输入"></el-input>
        </div>
      </template>
    </template>

    <template #btn-group>
      <el-button type="primary" class="list-btn" @click="handleSettle" :disabled="!selectedRows.length">
        结算
      </el-button>
      <el-button type="success" class="list-btn" @click="handleSettleAll">
        全部结算
      </el-button>
      <el-button type="warning" class="list-btn" @click="handleCalcPoints">
        计算
      </el-button>
      <span class="selected-count" v-if="selectedRows.length > 0">已选 {{ selectedRows.length }} 条</span>
      <span class="sum-info-bar" v-if="sumInfo.visible">
        <span class="sum-label">{{ sumInfo.label }}：</span>
        <span class="sum-count">{{ sumInfo.count }} 条</span>
        <span class="sum-divider">|</span>
        <span class="sum-points">积分合计 <strong>{{ sumInfo.totalPoints }}</strong></span>
      </span>
    </template>

    <template #table-column>
      <el-table-column prop="recordId" label="兑换记录编号" align="center" width="220"></el-table-column>
      <el-table-column prop="verifyUsername" label="核验员" align="center" width="100">
        <template #default="scope">{{ scope.row.verifyUsername || '-' }}</template>
      </el-table-column>
      <el-table-column prop="itemName" label="物品名称" align="center" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="requiredPoints" label="消耗积分" align="center" width="100"></el-table-column>
      <el-table-column prop="verifyTime" label="核验时间" align="center" width="180">
        <template #default="scope">
          {{ $formatTime(scope.row.verifyTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="settleStatus" label="结算状态" align="center" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.settleStatus === '1' ? 'success' : 'warning'">
            {{ scope.row.settleStatus === '1' ? '已结算' : '待结算' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="settleTime" label="结算时间" align="center" width="auto" :resizable="false">
        <template #default="scope">
          {{ scope.row.settleTime ? $formatTime(scope.row.settleTime) : '-' }}
        </template>
      </el-table-column>
    </template>
  </CommonList>
</template>

<script setup>
  import { ref } from 'vue';
  import useVerifyRecordList from './VerifyRecordList.js';

  const listRef = ref(null);

  const {
    isAdmin,
    searchForm,
    selectedRows,
    sumInfo,
    handleReset,
    handleSelectionChange,
    handleLoadList,
    handleSettle,
    handleSettleAll,
    handleCalcPoints
  } = useVerifyRecordList(listRef);
</script>

<style scoped>
  @import '../../../assets/css/util/base-list.css';

  .selected-count {
    margin-left: 10px;
    color: #909399;
    font-size: 13px;
  }

  .sum-info-bar {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-left: 12px;
    padding: 4px 12px;
    background-color: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 4px;
    color: #303133;
    font-size: 13px;
  }

  .sum-info-bar .sum-label {
    color: #409eff;
    font-weight: 500;
  }

  .sum-info-bar .sum-points strong {
    color: #e6a23c;
    font-size: 16px;
    margin-left: 4px;
  }

  .sum-info-bar .sum-divider {
    color: #dcdfe6;
  }
</style>
